var _style, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconeImporteSeusPdfsAgger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_6",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0PDF{fill:#005b87;}\r\n\t.st1PDF{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_3-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    className: "st0PDF",
    d: "M50,25c0,13.8-11.2,25-25,25S0,38.8,0,25S11.2,0,25,0S50,11.2,50,25"
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    className: "st1PDF",
    d: "M35.3,40.3H14.7c-0.9,0-1.7-0.8-1.7-1.7V11.4c0-0.9,0.8-1.7,1.7-1.7h15.4l6.8,6.8v22.1 C37,39.5,36.2,40.3,35.3,40.3z M14.7,11.4v27.2h20.5V18.2h-5.1c-0.9,0-1.7-0.8-1.7-1.7v-5.1H14.7z M30.1,12.1v4.4h4.4L30.1,12.1z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeImporteSeusPdfsAgger);
export default __webpack_public_path__ + "static/media/icone-importe-seus-pdfs-agger.ac8ebff602ef49652f5befafaf27273e.svg";
export { ForwardRef as ReactComponent };